import * as Yup from 'yup';

import i18n from '@/i18n';

export const createRegisterValidationSchema = () =>
  Yup.object().shape({
    firstName: Yup.string().required(i18n.t('firstNameRequired', { ns: 'common' })),
    lastName: Yup.string().required(i18n.t('lastNameRequired', { ns: 'common' })),
    email: Yup.string()
      .email(i18n.t('emailInvalid', { ns: 'common' }))
      .required(i18n.t('emailRequired', { ns: 'common' })),
    organizationName: Yup.string().required(i18n.t('organizationRequired', { ns: 'common' }))
  });
